export default __webpack_public_path__ + "static/media/project2.0e4e5ec6.png";